import trentialLogo from '@assets/branding/powered-by-trential-grey.svg';
import styles from '@auth/styles';
import LayoutContext from '@components/layout/context';
import { DATA_TEST_IDS } from '@data-test-ids';
import { useIsDesktop } from '@global/hooks';
import { Clear } from '@mui/icons-material';
import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery
} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { updateMiscStore } from '@redux/slices/misc';
import { RootState, store } from '@redux/store';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { linksData, LinksData } from './constants';

export default function Navigation() {
  const theme = useTheme();

  const openDemo = useSelector((s: RootState) => s.misc.openDemo);
  const auth: any = useSelector((s: RootState) => s.auth);
  const { accessToken } = auth;

  const { showContactUs } = useContext(LayoutContext);

  const matchesAboveSm = useMediaQuery(theme.breakpoints.up('sm'));

  //   React.useEffect(() => {
  //     if (!location.pathname.includes(links.EKYC)) {
  //       clearInterval(getFetchProcessInterval());
  //       updateDocumentTitle([pathnameToText(location.pathname, searchedQuery?.link)]);
  //     }
  //   }, [location.pathname, searchedQuery.link]);

  return (
    <>
      <Grid
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          // bgcolor: isDesktop ? '#F5FCFF' : '#ffffff',
          height: '100%'
        }}>
        {matchesAboveSm && accessToken ? (
          <Card
            variant="outlined"
            style={{
              height: '100%',
              // margin: '1em',
              display: 'flex',
              flexDirection: 'column'
            }}>
            <ListOfNavigation
              linksData={linksData}
              onClick={(text: string) => {
                linksData[text].onClick();
              }}
              showContactUs={showContactUs}
            />
            {import.meta.env.VITE_SHOW_TRENTIAL_BRANDING == true && (
              <>
                <Divider />
                <Box
                  sx={{
                    ...styles.poweredBy,
                    marginTop: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '1em'
                  }}>
                  <img
                    src={trentialLogo}
                    alt="trential"
                    style={{ height: '1.5rem', width: 'auto', margin: '1em' }}
                  />
                </Box>
              </>
            )}
          </Card>
        ) : null}
      </Grid>

      {import.meta.env.VITE_DEMO_VIDEO_LINK ? (
        <Dialog
          maxWidth="md"
          fullWidth
          open={openDemo}
          onClose={() => {
            store.dispatch(updateMiscStore({ openDemo: false }));
          }}
          sx={{ padding: '1em' }}>
          <DialogTitle>
            <Typography variant="body1">Watch Demo</Typography>
            <IconButton
              sx={{ position: 'absolute', top: '0px', right: '0.5em' }}
              onClick={() => {
                store.dispatch(updateMiscStore({ openDemo: false }));
              }}>
              <Clear />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ padding: '1em', width: '100%' }}>
            <video style={{ width: '100%', margin: 'auto' }} controls controlsList="nodownload">
              <source
                src={import.meta.env.VITE_DEMO_VIDEO_LINK}
                type="video/mp4"
                data-test-id={DATA_TEST_IDS.DEMO_VIDEO_SOURCE}
              />
              Your browser does not support HTML video.
            </video>
          </DialogContent>
        </Dialog>
      ) : null}
    </>
  );
}

export const ListOfNavigation = ({
  linksData,
  onClick,
  showContactUs
}: {
  linksData: LinksData,
  onClick: (a: string) => void,
  showContactUs: boolean
}) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: window.window.innerWidth * 0.7
      }}>
      <List sx={{ flexGrow: 1 }}>
        {linksData &&
          Object.keys(linksData).length > 0 &&
          Object.keys(linksData)?.map((text: string) => (
            <ListItem
              key={text}
              id={text}
              disablePadding
              secondaryAction={linksData[text]?.secondaryAction}
              divider={linksData[text]?.divider}>
              <ListItemButton
                color="primary"
                onClick={() => {
                  onClick(text);
                }}>
                <ListItemIcon color="primary" sx={{ minWidth: '0', margin: '8px' }}>
                  {linksData?.[text]?.icon(window.location.pathname === linksData[text]?.link)}
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  secondary={linksData?.[text]?.subtitle}
                  primaryTypographyProps={{
                    color: window.location.pathname === linksData[text].link ? 'primary' : '',
                    fontWeight: 600,
                    fontSize: '1.6rem'
                  }}
                  secondaryTypographyProps={{
                    color: theme.palette.secondary.main,
                    fontStyle: 'italic',
                    margin: '0'
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
      </List>

      {/* Contact Us aligned at the bottom */}
      {showContactUs && (
        <>
          {isDesktop && (
            <Box sx={{ width: '20vw', padding: '2.4rem' }}>
              <Typography variant="body1" component="p" sx={{ fontWeight: '700' }}>
                Contact Us
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 1, lineHeight: 1.5 }}
                data-test-id={DATA_TEST_IDS.CONTACT_PHONE_TEXT}>
                Call us at{' '}
                <strong>
                  {import.meta.env.VITE_ORG == 'NEU' ? '+1 (650) 305 5384' : '+91-9667766726'}
                </strong>{' '}
                between <strong>11 AM - 7 PM (Indian Standard Time)</strong>, Monday to Friday. The
                provided contact number is for calls only and is not available for WhatsApp or SMS
                communications.
              </Typography>
            </Box>
          )}
          {!isDesktop && (
            <Box
              sx={{
                padding: '3em',
                width: '100%',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                display: 'flex'
              }}>
              <Box>
                <Typography variant="h6" component="p">
                  Contact Us
                </Typography>
                <Typography
                  sx={{ mt: 1, lineHeight: 1.5 }}
                  data-test-id={DATA_TEST_IDS.CONTACT_PHONE_TEXT_MOBILE}>
                  Call us at{' '}
                  <a href="tel:+9667766726">
                    <strong>
                      {import.meta.env.VITE_ORG == 'NEU' ? '+1 (650) 305 5384' : '+91-9667766726'}
                    </strong>
                  </a>{' '}
                  between <strong>11 AM - 7 PM (Indian Standard Time)</strong>, Monday to Friday.
                  The provided contact number is for calls only and is not available for WhatsApp or
                  SMS communications.
                </Typography>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
